import { Component, Input, OnInit, OnChanges } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { SubscriberInformationService } from './SubscriberInformationService';
import { isNullOrUndefined } from '../objectUtils';
import { MaskFieldsService } from '../MaskService/mask-fieds.service';
//import DateHelpers from '../DateHelpers';

@Component({
    selector: 'subscriber-info',
    templateUrl: './subscriber-info.component.html',
    styleUrls: ['./subscriber-info.component.scss'],
    standalone: false
})

export class SubscriberInfoComponent implements OnInit, OnChanges {
   
  @Input() subscriberNumber: number;
  public subscriberInfo: models.SubscriberInformationVM = <models.SubscriberInformationVM>{};
  @Input() displaySubscriberInfo: boolean;
  @Input() instanceId: number;
  @Input() workflowCode: string;
  @Input() userNumber: number;

  @Input() isMaskOn: boolean = false;



  public normalizedDates = false;
  //PIT39686 - Start
  public fiscalNumberVisible = true;
  //PIT39686 - End
  //PIT39680 - Start
  public allowSharedData = false;
  //PIT39680 - End
  constructor(
    private http: HttpClient,
    private subscriberInfoservice: SubscriberInformationService,
    private maskFieldService: MaskFieldsService) { }

  //LIFECYCLE
  ngOnInit(): void {
   
  }
  ngOnChanges(changes: import("@angular/core").SimpleChanges): void {
    if (this.subscriberNumber)
      this.loadSubscriberDetails();

  }


  public getMaskDate(value: Date) {
    return this.maskFieldService.getMaskDate(value);
  }


  ngDoCheck(): void {
    if (this.normalizedDates === false && this.subscriberInfo.dateOfBirth) {
      this.subscriberInfo.dateOfBirth = new Date(this.subscriberInfo.dateOfBirth);
      this.normalizedDates = true;
    }
  }

  //INTERNAL API CALLS
  /**
  * Load subscriber information for a given subscriber
  *
  * @remarks
  * This is an api call
  *
  */
  public loadSubscriberDetails() {
    if (!isNullOrUndefined(this.subscriberNumber) && this.subscriberNumber != 0) {
      let instance = isNullOrUndefined(this.instanceId) ? null : this.instanceId;
      if (isNullOrUndefined(instance)) {
        if (this.workflowCode.indexOf("PEDI0020") > -1 || this.workflowCode.indexOf("PEDI0001") > -1 ) {
          instance = -2;
        } else {
          instance = -1;
        }

      }
      if (this.workflowCode == "PEDI008B") {
        this.fiscalNumberVisible = false;
      }
      this.subscriberInfoservice.setCurrentSubscriber(this.subscriberNumber, instance, this.workflowCode).subscribe(() => {
          this.subscriberInfoservice.getCurrentSubscriber().subscribe(result => {
            this.subscriberInfo = result;
            //PIT39680 - Start
            this.allowSharedData = this.subscriberInfo.sharedData == 'S' ? true : false;
            //PIT39680 - End
          });
      });
    }
  }
}
